import { Input as ChakraInput } from '@chakra-ui/react'
import styled from '@emotion/styled'
import {theme} from "@chakra-ui/react";

const Input = styled(ChakraInput)`
    border: 1px solid ${theme.colors.purple[500]};
    color: #FCFCFD;
    border-radius: 8px;
    background: #23262F;
    &::placeholder { 
        color: #777E90;
        opacity: 1;
    }
      
    &:-ms-input-placeholder { 
        color: #FCFCFD;
    }
      
    &::-ms-input-placeholder { 
        color: #FCFCFD;
    }
    &:focus {
        box-shadow: none;
        outline: none;
        border-color: unset;
    }
`
export default Input
